export default __webpack_public_path__ + "static/media/ISFJ-4.87f09bf7.png";